import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import logo from "../images/logo.svg";
import { setSearchKey } from '../redux/features/projects/projectFilterSlice';

const Navbar = () => {
  const {pathname}=useLocation();
  const dispatch=useDispatch();
  const {searchKey}=useSelector(state=>state.filterProjects)



  return (

    <>
    
    <nav className="container relative py-3">
    <div className="flex items-center justify-between">
      <Link to="/">
        <img src={logo} />
      </Link>
      { pathname=='/' && <div className="flex-1 max-w-xs search-field group">
        <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
        <input type="text" value={searchKey} placeholder="Search Task" className="search-input text-[#111827]" id="lws-searchTask" onChange={(e)=>dispatch(setSearchKey(e.target.value))} />
      </div>}
    </div>
  </nav>
    </>
  )
}

export default Navbar